export class SchedulePostDTO {
    switchId: number;
    scheduledStartTime: Date | null;
    scheduledEndTime: Date | null;

    constructor(switchId: number, scheduledStartTime: Date | null, scheduledEndTime: Date | null) {
        this.switchId = switchId;
        this.scheduledStartTime = scheduledStartTime;
        this.scheduledEndTime = scheduledEndTime;
    }
}
